import { Directive } from '@angular/core';

@Directive({
  selector: 'xpo-select-two-columns-container , xpoSelectTwoColumnsContainer',
  host: {
    class: 'xpo-Select-twoColumnsContainer',
  },
})
export class XpoSelectTwoColumnsContainer {}
